import { Box } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

const messageSx = {
  padding: "20px",
  maxWidth: "500px",
  width: "500px",
  borderRadius: "5px",
  backgroundColor: "grey.300"
};

const Message = ({ firstName }) => {
  return (
    <Box sx={messageSx}>{firstName}, your subscription preferences have been updated. Thank you!</Box>
  );
};

Message.propTypes = {
  firstName: PropTypes.string
};

export default Message;
